<template>
  <div class="menu-credits">
    <a target="_blank" href="https://thevisualagency.com/">The Visual Agency</a>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.menu-credits {
  .mobile &,
  .tablet & {
    @include ButtonM;
    text-decoration: none;
    color: $white;
    a {
      color: $white;
    }
  }
  .desktop & {
    @include ButtonS;
    text-decoration: none;
    color: $white-50;
    a {
      color: $white-50;
      &:hover {
        color: #fff;
      }
    }
  }
}
</style>